<template>
  <div>
    <custom-actions show-back>
      <el-form
        class="global-form shoufa-form"
        :model="formData"
        ref="form"
        label-width="160px"
        v-loading="loading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="typeName" label="规格类型">
              {{ formData.typeName || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="priceDiff" label="价格差">
              {{ formData.priceDiff || "" }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="currentPrice" label="当前单价">
              {{ formData.currentPrice || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row> -->
          <el-col :span="12">
            <el-form-item prop="isPublished" label="是否发布">
              {{
                formData.isPublished == "0"
                  ? "未发布"
                  : formData.isPublished == "1"
                  ? "已发布"
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isDisplay" label="是否展示">
              {{
                formData.isDisplay == "1"
                  ? "是"
                  : "否"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isBulkOil" label="是否散油">
              {{
                formData.isBulkOil == "0"
                  ? "否"
                  : formData.isBulkOil == "1"
                  ? "是"
                  : ""
              }}
            </el-form-item>
          </el-col>
        <!-- </el-row>

        <el-row> -->
          <el-col :span="12">
            <el-form-item prop="unit" label="单位">
              {{ formData.unit || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="productCode" label="商品编号">
              {{ formData.productCode || "" }}
            </el-form-item>
          </el-col>
          <!-- 暂时隐藏详情中的用友系数，恢复时取消此注释。
          <el-col :span="12">
            <el-form-item prop="yonyouCoefficient" label="用友系数">
              {{ formData.yonyouCoefficient == null ? 1 : formData.yonyouCoefficient }}
            </el-form-item>
          </el-col>
          -->
          <el-form-item prop="orderNum" label="排序">
            {{ formData.orderNum||'' }}
            </el-form-item>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="图片" prop="specImage">
              <el-image
                style="width: 60px; height: 60px"
                :src="formData.specImage || YouImg"
                :preview-src-list="[formData.specImage || YouImg]"
                fit="cover"
              />
              <!-- <el-image v-else style="width: 60px; height: 60px" src="@/assets/you.png"
              :preview-src-list="['@/assets/you.png']" fit="cover" /> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import YouImg from '../../assets/you.png'
export default {
  name: 'GrainSpecificationsDetail',

  data () {
    return {
      YouImg,
      typeArr: [],

      formData: {
        typeId: '',
        specName: '',
        priceDiff: '',
        currentPrice: '',
        isPublished: '',
        isBulkOil: '',
        unit: '',
        productCode: '',
        specImage: ''
      },

      loading: false,

      goodsCodeList: [],

      dialogVisible: false,
      currentImageIndex: 0
    }
  },
  created () {
    this.loadDict()
    if (this.specId) {
      this.loadData()
    }
  },
  computed: {
    specId () {
      return this.$route.query.specId
    }
  },
  methods: {
    loadDict () {
      this.$axios
        .get(this.$apis.common.selectDicByList, {
          params: { dicType: 'goodsCode' }
        })
        .then(res => {
          this.goodsCodeList = res.goodsCode
        })
    },
    onPreview (file) {
      console.log('file', file)
      if (
        file.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(
          file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        )
      ) {
        this.currentImageIndex = this.imageList.findIndex(
          url => url.name === file.name
        )
        this.dialogVisible = true
      } else {
        window.open(file.url, '_blank')
      }
    },

    handleSuccess (res) {
      console.log('res: ', res)
      const file = res.data
      this.formData.specImage = file.filePrefix + file.fileUrl
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecBySpecId, {
          params: { specId: this.specId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.grainSpecifications.insertYxOilSpec
          if (this.specId) {
            url = this.$apis.grainSpecifications.updateYxOilSpec
          }
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
